import {
  Sparkles, TrendingUp, Users, Heart, Package,
  Zap, Compass, Leaf, Crown, Calculator,
} from "lucide-react";

// Icon lookup keyed on the string names emitted by /api/personas.
export const PERSONA_ICONS = {
  Sparkles, TrendingUp, Users, Heart, Package,
  Zap, Compass, Leaf, Crown, Calculator,
};

/**
 * PersonaBadge — pill with the persona's icon in their color, followed by
 * the persona id + name. Use anywhere the founder needs to see WHICH advisor
 * is speaking.
 */
export default function PersonaBadge({ persona, size = "md" }) {
  if (!persona) return null;
  const Icon = PERSONA_ICONS[persona.icon] || Sparkles;
  const color = persona.color || "#334155";
  const px = size === "sm" ? "px-2 py-1" : "px-2.5 py-1.5";
  const iconSize = size === "sm" ? 12 : 14;
  const textSize = size === "sm" ? "text-[0.65rem]" : "text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md font-semibold mono-caps ${px} ${textSize}`}
      style={{ backgroundColor: `${color}15`, color, border: `1px solid ${color}30` }}
      data-testid={`persona-badge-${persona.id}`}
    >
      <Icon size={iconSize} strokeWidth={2.4} />
      <span>{persona.id}</span>
      <span className="opacity-70">·</span>
      <span className="normal-case tracking-normal font-medium">{persona.name}</span>
    </span>
  );
}
